// extracted by mini-css-extract-plugin
module.exports = {"blogPostTagWrapper":"Tag_blogPostTagWrapper__QiooF","blogPostTag":"Tag_blogPostTag__Mi8l_"};